import {IAuthUserInfo} from '@chancer/common/lib/interfaces/auth/AuthInterfaces';
import {IAction, ActionType} from '../Actions';

export const authResponse = (
  user: IAuthUserInfo | null,
): IAction<IAuthUserInfo | null> => ({
  payload: user,
  type: ActionType.AUTH_MESSAGE,
});
